module.exports = __webpack_public_path__ + "static/voorlater-3-ad0a0521cb60ffdb5855171698e77c85.png";